import { render } from "./IndexTables.vue?vue&type=template&id=b1747ae0"
import script from "./IndexTables.vue?vue&type=script&lang=js"
export * from "./IndexTables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__